import axios from 'axios'
import {IVoucherRequest} from '../../coreGlobal/models/voucher'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const VOUCHER_URL = `${API_URL}/vouchers`

const getSearchVoucher = (query: string): Promise<IVoucherRequest> => {
  return axios
    .get(`${VOUCHER_URL}/find-by-code/${query}`)
    .then((response) => response.data)
    .then((response) => response.data)
}

export {getSearchVoucher}
